<template>
    <button
        class="btn"
        :type="type"
        @click="onClick"
        :class="{
            'btn-primary': variant === 'primary',
            'btn-secondary': variant === 'secondary',
            'btn-outline-dark': variant === 'outline-dark',
            outline:
                variant === 'outline-primary' ||
                variant === 'outline-secondary',
            'outline-primary': variant === 'outline-primary',
            'outline-secondary': variant === 'outline-secondary',
            'text-primary': variant === 'text-primary',
            'text-secondary': variant === 'text-secondary',
            'text-error': variant === 'text-error',
            disabled: disabled === true,
            'tiny-btn': tiny === true,
            'extended-btn': extended === true,
            'no-outline': outline === false,
        }"
        :disabled="disabled"
    >
        <slot v-if="!disabled || !disabledHint" />
        <template v-else>{{ disabledHint }}</template>
    </button>
</template>

<script>
export default {
    props: {
        variant: String,
        type: String,
        click: {
            type: Function,
            default: () => {},
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        disabledHint: String,
        tiny: Boolean,
        extended: Boolean,
        outline: Boolean,
    },
    methods: {
        onClick() {
            this.$emit('click', this.click);
        },
    },
};
</script>

<style>
.btn:hover:not(.disabled) {
    filter: brightness(97%);
}

.no-outline:focus {
    outline: none;
    box-shadow: none;
}

/* Primary colors */

/* Primary */
.btn-primary {
    background-color: var(--primary) !important;
    border-color: var(--primary) !important;
}
.btn-primary:hover:not(.disabled) {
    filter: brightness(96%);
}

.btn-primary:active .outline-primary:active .text-primary:active {
    filter: brightness(90%);
}

/* Primary Outlined */
.outline-primary {
    border-color: var(--primary);
    color: var(--primary);
}
.outline-primary:hover:not(.disabled) {
    background-color: var(--primary);
    color: white;
}
.outline-primary:active {
    border-color: var(--primary);
    outline-width: 2px;
    outline-color: var(--primary);
}

/* Primary Text */
.text-primary {
    color: var(--primary) !important;
}

/* Secondary colors */

/* Secondary */
.btn-secondary {
    background-color: var(--secondary) !important;
    border-color: var(--secondary) !important;
}
.btn-secondary:hover:not(.disabled) {
    filter: brightness(96%);
}
.btn-secondary:active,
.outline-secondary:active .text-secondary:active {
    filter: brightness(90%);
}

/*Secondary outlined*/
.outline-secondary {
    border-color: var(--secondary);
    color: var(--secondary) !important;
}
.outline-secondary:hover:not(.disabled) {
    background-color: var(--secondary);
    color: white !important;
}

/* Secondary text */
.text-secondary {
    color: var(--secondary) !important;
}

/* Sizes */
.tiny-btn {
    padding: 2px 8px !important;
}

.extended-btn {
    border-radius: 22px;
}

/* Error */
.text-error {
    color: var(--error) !important;
}

.disabled {
    cursor: default;
}

.disabled.outline {
    background-color: rgba(0, 0, 0, 0.2) !important;
    border-color: rgb(0.8, 0.8, 0.8) !important;
    color: rgb(0.8, 0.8, 0.8) !important;
}
</style>
